import script from "./VerifyCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyCustomer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__